// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css';
import config from '../src/config'
import axios from 'axios'
import 'animate.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import moment from 'moment'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
Vue.config.productionTip = false
Vue.prototype.config=config
Vue.prototype.$axios=axios 
Vue.use(iView)
Vue.prototype.$moment = moment

import UUID from 'vue-uuid'
Vue.use(UUID)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js